import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Stock movement analytics. The window defaults wide because the ledger only
// began on 2 September — there is no long history to slice yet.
export function useStockAnalytics({ days = 30, storeroomId } = {}) {
  const p = new URLSearchParams();
  p.set('days', String(days));
  if (storeroomId) p.set('storeroom_id', String(storeroomId));
  return useQuery({
    queryKey: ['stockAnalytics', String(days), String(storeroomId || '')],
    queryFn: async () => (await api.get(`/api/inventory/analytics?${p.toString()}`)).data,
    staleTime: 60 * 1000,
  });
}
